import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import {
  adminRoleSelector,
  allThresholdCellSelectionSelector,
  autoSortEnabledSelector,
  filtersViewSelector,
  nocModeSelector,
  redirectedFromNocSelector,
  trendsViewSelector,
  unsavedThresholdSelector
} from '../base/selectors';

const selector = state => get(state, SCOPE);

export default selector;

export const dashboardResponseSelector = createSelector(
  selector,
  (store) => {
    const { response } = store;
    if (!response) {
      return null;
    }

    if (!response.config.base) {
      response.config.base = {};
    }
    return response;
  },
);

export const savingSelector = createSelector(
  nocModeSelector,
  filtersViewSelector,
  trendsViewSelector,
  unsavedThresholdSelector,
  allThresholdCellSelectionSelector,
  adminRoleSelector,
  autoSortEnabledSelector,
  redirectedFromNocSelector,
  (
    nocMode,
    filters,
    trends,
    unsavedThresholdChanges,
    allThresholdSelection,
    isAdminRole,
    isAutoSortEnabled,
    isRedirectedFromNocTiles,
  ) => {
    return {
      dashboard_version: '2.0',
      base: {
        mode: nocMode,
        filters,
        trends,
        unsavedThresholdChanges,
        allThresholdSelection,
        isAdminRole,
        isAutoSortEnabled,
        isRedirectedFromNocTiles,
      }
    }
  }
)

export const dashboardIsFetchingSelector = createSelector(
  selector,
  store => store.isFetching,
);
